import React, { Fragment } from "react";
import { v4 as uuidv4 } from "uuid";
import Checkbox from "./Checkbox";
import Field from "./Field";
import Radio from "./Radio";
import Textarea from "./Textarea";
import Select from "./Select";

const TableFields = ({ field, handleFieldChanged, values, showSimplifiedOptions, handlePrefillOptions, type }) => {
  /* console.log("---------------------- Table Fields ---------------------", showSimplifiedOptions); */
  const rowData = field.fields.filter((v, i) => {
    return v.hasOwnProperty("component") && v.component === "row" ? v : null;
  });

  const rowColumnData = field.fields.filter((v, i) => {
    return v.hasOwnProperty("fields") && v.fields && v.fields.length > 0 ? v.fields : null;
  });

  const fieldMeetsCondition = (values) => (field) => {
    if (field.conditional && field.conditional.field) {
      console.log("Inside table fields components", field);
      const segments = field.conditional.field.split("_");
      const fieldId = segments[segments.length - 1];

      console.log("fieldId", fieldId);
      console.log("values[fieldId]", values[fieldId]);

      if (field.type === "textarea") {
        return true;
      } else {
        return values[fieldId] === field.conditional.value;
      }
    }

    return true;
  };

  return (
    <div className="medium-12">
      {/* Row data */}
      {/* {field.hasOwnProperty("caption") && field.caption ? (
        Array.isArray(field.caption) ? (
          field.caption.map((v, i) => {
            return <p>{v}</p>;
          })
        ) : (
          <p>
            <strong>{field.caption}</strong>
          </p>
        )
      ) : (
        ""
      )} */}
      {(showSimplifiedOptions === true &&
        field &&
        field.hasOwnProperty("simplifiedBoldCaption") &&
        field.simplifiedBoldCaption &&
        ((Array.isArray(field.simplifiedBoldCaption) &&
          field.simplifiedBoldCaption.map((v, i) => {
            return (
              <p style={{ marginBottom: "0px" }}>
                <b>{v}</b>
              </p>
            );
          })) || (
          <p>
            <b>{field && field.simplifiedBoldCaption}</b>
          </p>
        ))) ||
        (field &&
          field.hasOwnProperty("boldCaption") &&
          Array.isArray(field.boldCaption) &&
          field.boldCaption.map((v) => {
            return (
              <p>
                <b>{v}</b>
              </p>
            );
          })) || (
          <p>
            <b>{field && field.boldCaption}</b>
          </p>
        )}

      {(showSimplifiedOptions === true &&
        field &&
        field.hasOwnProperty("simplifiedCaption") &&
        field.simplifiedCaption &&
        ((Array.isArray(field.simplifiedCaption) &&
          field.simplifiedCaption.map((v, i) => {
            return (
              /* i === 0 &&  */ <p style={{ marginBottom: "0px" }}>{v}</p> /* || (
                <p>
                  <small>{v}</small>
                </p>
              ) */
            );
          })) || (
          <p>
            <b>{field && field.simplifiedCaption}</b>
          </p>
        ))) ||
        (field &&
          field.hasOwnProperty("caption") &&
          Array.isArray(field.caption) &&
          field.caption.map((v) => {
            return <p>{v}</p>;
          })) || <p>{field && field.caption}</p>}

      {showSimplifiedOptions === true &&
        field &&
        field.hasOwnProperty("simplifiedBoldHeaderBelowSimplifiedCaption") &&
        field.simplifiedBoldHeaderBelowSimplifiedCaption &&
        ((Array.isArray(field.simplifiedBoldHeaderBelowSimplifiedCaption) &&
          field.simplifiedBoldHeaderBelowSimplifiedCaption.map((v, i) => {
            return (
              /* i === 0 &&  */ <p style={{ marginBottom: "0px" }}>{v}</p> /* || (
                <p>
                  <small>{v}</small>
                </p>
              ) */
            );
          })) || (
          <p>
            <b>{field && field.simplifiedBoldHeaderBelowSimplifiedCaption}</b>
          </p>
        ))}

      {field.hasOwnProperty("simplifiedNotes") && field.simplifiedNotes && Array.isArray(field.simplifiedNotes) ? (
        field.simplifiedNotes.map((v, i) => {
          return <p style={{ fontSize: "16px" }}>{v}</p>;
        })
      ) : (
        <p style={{ fontSize: "16px" }}>{field.simplifiedNotes}</p>
      )}

      {field.hasOwnProperty("description") && field.description ? <p>{field.description}</p> : ""}

      {/* Row Data */}
      {rowData && rowData.length > 0 ? (
        <table className="3343434">
          <tbody>
            {rowData.map((v, i) => {
              return (
                <tr>
                  <td width="50%">
                    {(showSimplifiedOptions === true && v.hasOwnProperty("simplifiedLabel") && v.simplifiedLabel) ||
                      v.label}

                    {v.hasOwnProperty("description") && v.description && v.description.length > 0 ? (
                      <Fragment>
                        <p>For example:</p>
                        <ul>
                          {v.description.map((v, i) => {
                            return <li>{v}</li>;
                          })}
                        </ul>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </td>
                  <td width="50%">
                    {v.type === "text" ? (
                      <Field
                        key={v._uid}
                        field={v}
                        handleFieldChanged={handleFieldChanged}
                        value={values[v._uid]}
                        showSimplifiedOptions={showSimplifiedOptions}
                      />
                    ) : v.type === "radio" ? (
                      <Radio
                        key={v._uid}
                        field={v}
                        handleFieldChanged={handleFieldChanged}
                        value={values[v._uid]}
                        showSimplifiedOptions={showSimplifiedOptions}
                      />
                    ) : v.type === "textarea" ? (
                      <Textarea
                        key={v._uid}
                        field={v}
                        handleFieldChanged={handleFieldChanged}
                        value={values[v._uid]}
                        showSimplifiedOptions={showSimplifiedOptions}
                      />
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        ""
      )}

      {/* Row coulmn data */}
      {rowColumnData && rowColumnData.length > 0 ? (
        <>
          <div className="fixTableHead">
            <table className="testTable">
              {field.hasOwnProperty("headers") && field.headers && field.headers.length && (
                <thead>
                  <tr>
                    {field.headers.map((v, i) => {
                      if (typeof v === "object" && v !== null && !Array.isArray(v)) {
                        if (v.value && Array.isArray(v.value) && v.value.length > 0) {
                          {
                            return (
                              <th colSpan={v.colSpan} width={v.width ? v.width : ""}>
                                {v.value.map((iv, ii) => {
                                  return (
                                    (ii === 0 && <p style={{ margin: "0" }}>{iv}</p>) || (
                                      <small style={{ fontWeight: "normal" }}>{iv}</small>
                                    )
                                  );
                                })}
                              </th>
                            );
                          }
                        } else {
                          return (
                            <th colSpan={v.colSpan} width={v.width ? v.width : ""}>
                              {v.value}
                            </th>
                          );
                        }
                      } else if (Array.isArray(v)) {
                        return (
                          <th>
                            {v.map((iv, ii) => {
                              return (
                                (ii === 0 && <p style={{ margin: "0" }}>{iv}</p>) || (
                                  <small style={{ fontWeight: "normal" }}>{iv}</small>
                                )
                              );
                            })}
                          </th>
                        );
                      } else {
                        return <th>{v}</th>;
                      }
                    })}
                  </tr>
                </thead>
              )}

              <tbody>
                {/* <tr>
                <td colSpan={"3"}>
                  <div className="grid-x grid-padding-x">
                    <div className="cell small-2">1.2.2</div> 
                    <div className="cell small-6">
                      All changes to network  connections and to configurations of NSCs are approved and managed in
                      accordance with the change control process defined at Requirement 6.5.1.
                    </div>
                    <div className="cell small-4">
                      Examine documented procedures. Examine network configurations. Examine change control records.
                      Interview responsible personnel.
                    </div>
                  </div>
                  <div
                    className="grid-x grid-padding-x"
                    style={{ marginTop: "25px", background: "#808080", color: "#fff" }}
                  >
                    <div className="cell medium-10 medium-offset-2">
                      <b>Applicability Notes</b>
                    </div>
                  </div>
                  <div className="grid-x grid-padding-x" style={{ marginTop: "20px" }}>
                    <div className="cell medium-10 medium-offset-2">
                      Notes Changes to network connections include the addition, removal, or modification of a
                      connection. Changes to NSC configurations include those related to the component itself as well as
                      those affecting how it performs its security function.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="radio" />
                </td>
                <td>
                  <textarea
                    id="399a9324-2caf-4ad9-97de-0524f08ab98u"
                    rows="12"
                    maxlength="320"
                    placeholder="Please explain the reason of N/A"
                    disabled=""
                  ></textarea>
                </td>
              </tr> */}

                {rowColumnData &&
                  rowColumnData.length &&
                  rowColumnData.map((v, i) => {
                    return (
                      <tr key={v._uid}>
                        {v.fields.filter(fieldMeetsCondition(values)).map((iv, ii) => {
                          return (
                            <td
                              key={iv._uid}
                              width={iv.hasOwnProperty("width") && iv.width ? iv.width : ""}
                              colSpan={iv.hasOwnProperty("colSpan") && iv.colSpan ? iv.colSpan : 1}
                            >
                              {iv.type === "select" ? (
                                <Select
                                  key={iv._uid}
                                  field={iv}
                                  handleFieldChanged={handleFieldChanged}
                                  value={values[iv._uid]}
                                  showSimplifiedOptions={showSimplifiedOptions}
                                  handlePrefillOptions={handlePrefillOptions}
                                  type={type}
                                />
                              ) : iv.type === "text" ? (
                                <Field
                                  key={iv._uid}
                                  field={iv}
                                  handleFieldChanged={handleFieldChanged}
                                  value={values[iv._uid]}
                                  showSimplifiedOptions={showSimplifiedOptions}
                                />
                              ) : iv.type === "checkbox" ? (
                                <Checkbox
                                  key={iv._uid}
                                  field={iv}
                                  handleFieldChanged={handleFieldChanged}
                                  value={values[iv._uid]}
                                  showSimplifiedOptions={showSimplifiedOptions}
                                />
                              ) : iv.type === "radio" ? (
                                <Radio
                                  key={iv._uid}
                                  field={iv}
                                  handleFieldChanged={handleFieldChanged}
                                  value={values[iv._uid]}
                                  showSimplifiedOptions={showSimplifiedOptions}
                                />
                              ) : iv.type === "textarea" ? (
                                <>
                                  <Textarea
                                    key={iv._uid}
                                    field={iv}
                                    handleFieldChanged={handleFieldChanged}
                                    value={values[iv._uid]}
                                    showSimplifiedOptions={showSimplifiedOptions}
                                    values={values}
                                  />
                                </>
                              ) : showSimplifiedOptions === true &&
                                iv &&
                                iv.hasOwnProperty("simplifiedLabel") &&
                                iv.simplifiedLabel ? (
                                Array.isArray(iv.simplifiedLabel) ? (
                                  iv.simplifiedLabel.length > 0 && iv.hasOwnProperty("hasLi") && iv.hasLi !== "no" ? (
                                    <ul>
                                      {iv.simplifiedLabel.map((v, i) => {
                                        return <li>{v}</li>;
                                      })}
                                    </ul>
                                  ) : (
                                    iv.simplifiedLabel.map((v, i) => {
                                      return <p>{v}</p>;
                                    })
                                  )
                                ) : (
                                  <p>{iv && iv.simplifiedLabel ? iv.simplifiedLabel : ""}</p>
                                )
                              ) : iv && iv.hasOwnProperty("label") && iv.label && Array.isArray(iv.label) ? (
                                iv.hasOwnProperty("hasLi") && iv.hasLi !== "no" ? (
                                  <ul>
                                    {iv.label.map((v, i) => {
                                      return <li>{v}</li>;
                                    })}
                                  </ul>
                                ) : (
                                  iv.label.map((v, i) => {
                                    return <p>{v}</p>;
                                  })
                                )
                              ) : (
                                <p>{iv && iv.label}</p>
                              )}

                              {(iv &&
                                iv.hasOwnProperty("boldLabel") &&
                                Array.isArray(iv.boldLabel) &&
                                iv.boldLabel.map((v) => {
                                  return (
                                    <p style={{ marginBottom: 0 }}>
                                      <b>{v}</b>
                                    </p>
                                  );
                                })) ||
                                (iv.hasOwnProperty("boldLabel") && (
                                  <p style={{ marginBottom: 0 }}>
                                    <b>{iv.boldLabel}</b>
                                  </p>
                                ))}

                              {(iv.hasOwnProperty("subBoldLabel") &&
                                Array.isArray(iv.subBoldLabel) &&
                                iv.subBoldLabel.map((v) => {
                                  return (
                                    <p style={{ marginBottom: "10px", lineHeight: "18px" }}>
                                      <b>
                                        <small>{v}</small>
                                      </b>
                                    </p>
                                  );
                                })) ||
                                (iv.hasOwnProperty("subBoldLabel") && (
                                  <p style={{ marginBottom: 0 }}>
                                    <b>
                                      <small>{iv.subBoldLabel}</small>
                                    </b>
                                  </p>
                                ))}

                              {(iv.hasOwnProperty("subLabel") &&
                                Array.isArray(iv.subLabel) &&
                                iv.subLabel.map((v) => {
                                  return <p style={{ marginBottom: "10px", lineHeight: "18px" }}>{v}</p>;
                                })) ||
                                (iv.hasOwnProperty("subLabel") && <p style={{ marginBottom: 0 }}>{iv.subLabel}</p>)}

                              {iv.hasOwnProperty("subBoldLabelWithUl") && iv.subBoldLabelWithUl ? (
                                <Fragment>
                                  <p>
                                    <b>
                                      <small>{iv.subBoldLabelWithUl.simplifiedLabel}</small>
                                    </b>
                                  </p>

                                  <ul>
                                    {iv.subBoldLabelWithUl.ul.map((v, i) => {
                                      return (
                                        <li>
                                          <b>
                                            <small>{v}</small>
                                          </b>
                                        </li>
                                      );
                                    })}
                                  </ul>

                                  {(iv.subBoldLabelWithUl.hasOwnProperty("pr") &&
                                    Array.isArray(iv.subBoldLabelWithUl.pr) &&
                                    iv.subBoldLabelWithUl.pr.map((v) => {
                                      return (
                                        <p>
                                          <b>
                                            <small>{v}</small>
                                          </b>
                                        </p>
                                      );
                                    })) ||
                                    (iv.subBoldLabelWithUl.pr && (
                                      <b>
                                        <small>{iv.subBoldLabelWithUl.pr}</small>
                                      </b>
                                    )) ||
                                    ""}
                                </Fragment>
                              ) : (
                                ""
                              )}

                              {iv.hasOwnProperty("labelWithUl") && iv.labelWithUl ? (
                                <Fragment>
                                  <p>
                                    {iv.labelWithUl.hasOwnProperty("simplifiedLabel")
                                      ? iv.labelWithUl.simplifiedLabel
                                      : iv.labelWithUl.hasOwnProperty("label") && iv.labelWithUl.label}
                                  </p>

                                  <ul>
                                    {iv.labelWithUl.ul.map((v, i) => {
                                      return <li>{v}</li>;
                                    })}
                                  </ul>

                                  {(iv.labelWithUl.hasOwnProperty("pr") &&
                                    Array.isArray(iv.labelWithUl.pr) &&
                                    iv.labelWithUl.pr.map((v) => {
                                      return <p>{v}</p>;
                                    })) ||
                                    (iv.labelWithUl.pr && iv.labelWithUl.pr) ||
                                    ""}
                                </Fragment>
                              ) : (
                                ""
                              )}

                              {iv.hasOwnProperty("noteBelowLabelWithUl") && iv.noteBelowLabelWithUl ? (
                                <Fragment>
                                  {iv.noteBelowLabelWithUl.labelWithUl}

                                  <div>
                                    {iv.noteBelowLabelWithUl.label.map((v, i) => {
                                      return <p>{v}</p>;
                                    })}
                                  </div>
                                </Fragment>
                              ) : (
                                ""
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default TableFields;
